<template>
  <v-card class="ps-4 mt-4 mb-4" flat>
    <AusBusDocuments v-if="this.partner_Data && this.partner_Data.partner_id==66" />

    <v-row v-else v-for="doc in EntityDocs" :key="doc.doc_name.name">
      <v-col cols="12" md="8">{{ doc.doc_name.name }} </v-col>
      <v-btn
        depressed
        color="success"
        title="Download & View"
        fab
        small
        class="ma-2"
        @click="openDoc(doc.doc_val)"
        v-if="doc.doc_val"
        ><v-icon> mdi-file-download</v-icon></v-btn
      >
      <v-menu
        v-model="doc.isactive"
        :close-on-content-click="false"
        fixed
        :nudge-width="400"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            depressed
            color="primary"
            class="ma-2"
            title="Update"
            dark
            v-bind="attrs"
            v-on="on"
            fab
            small
          >
            <v-icon dark small>
              {{ doc.doc_val ? "mdi-pencil" : "mdi-cloud-upload" }}</v-icon
            >
          </v-btn>
        </template>

        <v-card>
          <v-form ref="uploadDoc">
            <v-col cols="12"
              >{{ doc.doc_name.name }}<span style="color: #f00">*</span>
            </v-col>
            <v-col cols="12">
              <v-file-input
                v-model="doc.doc_val"
                dense
                accept="application/pdf"
                placeholder="Upload File"
                :error-messages="docError"
                outlined
                required
                prepend-icon=""
                @change="fileUpload($event)"
              >
                <template v-slot:append>
                  <v-icon aria-hidden="false" class="color-primary">
                    mdi-cloud-upload
                  </v-icon>
                </template>
              </v-file-input>
            </v-col>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                depressed
                text
                @click="(doc.isactive = false), (doc.doc_val = null)"
              >
                Cancel
              </v-btn>
              <v-btn
                depressed
                color="primary"
                text
                @click="uploadDocument(doc)"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-menu>
    </v-row>
    <OverlayPageVue :showOverlay="loader" />
  </v-card>
</template>

<script>
import { webbreakdown } from "@/utils/breakpoints";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import { IndbusinessDocs, SetbusinessDocs } from "@/utils/BusDocuments";
import businessService from "@/services/BusinessService/businessService.js";
import alerts from "@/mixins/alerts";
import AusBusDocuments from "./AusBusDocuments.vue";
export default {
  mixins: [alerts],
  data: () => ({
    webbreakdown,
    partner_Data: null,
    businessDocument: IndbusinessDocs(),
    SetBusinessdocs: SetbusinessDocs(),
    allSets: [
      "Private Limited Companies (Sdn Bhd)",
      "Sole-Proprietorship / Partnership",
      "Limited Liability Partnership",
    ],

    showPopup: false,
    EntityDocs: null,
    loader: false,
    dialog: false,
    isshowdoc: false,
    SelectedSrc: null,
    EntityName: "",
    document_name: null,
    docError: "",
    docUploadType: "alldocs",
    selectedDoc: {},
    docsupload: {},
    recievedDocs: [],
    menu: false,
    error: false,
    docrules: [(v) => !!v || "Document is required"],
  }),
  components: {
    OverlayPageVue,
    AusBusDocuments,
  },
  name: "BankDetails",
  props: {
    selctedEntity: {
      type: String,
    },
    hideForm: {
      type: String,
    },
  },

  validations() {},
  watch: {
    selctedEntity: {
      handler(newval) {
        this.docUploadType = "alldocs";
        this.EntityName = "Private Limited Companies (Sdn Bhd)";
        this.returnBusinessDocs(
          "Private Limited Companies (Sdn Bhd)",
          this.SetBusinessdocs
        );
        console.log(" this.EntityName", newval);
      },
    },
    hideForm: {
      handler(newval) {
        if (
          newval &&
          this.EntityName === "Private Limited Companies (Sdn Bhd)"
        ) {
          this.docUploadType = "alldocs";
          this.returnBusinessDocs(this.EntityName, this.SetBusinessdocs);
        }
      },
    },
    docUploadType(val) {
      if (val === "alldocs") {
        this.returnBusinessDocs(this.selctedEntity, this.SetBusinessdocs);
      } else {
        this.returnBusinessDocs(this.selctedEntity, this.businessDocument);
      }
    },
  },
  mounted() {
    this.partner_Data = JSON.parse(sessionStorage.getItem("send_partner_data"));
    console.log("doc123",this.partner_Data)
    this.getBusinessInfo();
    this.returnBusinessDocs(
      "Private Limited Companies (Sdn Bhd)",
      this.SetBusinessdocs
    );
  },
  computed: {},
  methods: {
    openDoc(docurl) {
      console.log(docurl);
      if (docurl) {
        this.loader = true;
        this.SelectedSrc = docurl;
        const url = docurl;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "excel.xlsx");
        document.body.appendChild(link);
        link.click();
        this.loader = false;
      } else {
        return "";
      }
    },
    async getBusinessInfo() {
      try {
        const response = await businessService.getuploaddocs(
          this.$route.query.id
        );
        if (response.data.status_code === 200) {
          this.docsupload = response.data.data[0];
          this.recievedDocs = this.EntityDocs.map((doc) => {
            for (let key in this.docsupload) {
              if (doc.doc_name.code === key) {
                console.log("ele", this.docsupload[`${key}`]);
                return {
                  doc_name: doc.doc_name,
                  doc_val: response.data.data[0][`${key}`],
                  doc_url: response.data.data[0][`${key}`],
                  isactive: false,
                };
              }
            }
          });
          this.EntityDocs = this.recievedDocs;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async uploadDocument(doc) {
      console.log("doc.doc_val", doc);
      if (doc.doc_val && !this.error) {
        this.docError = "";
        this.loader = true;
        let fileData = new FormData();
        fileData.append("document", doc.doc_val);
        try {
          const response = await businessService.uploadDocs(
            doc.doc_name.value,
            doc.doc_name.value_code,
            fileData,
            this.$route.query.customerid
          );
          if (response.data.status_code === 200) {
            this.showAlertSuccess(response.data.message);
            doc.isactive = false;
            this.loader = false;
          } else {
            this.showAlertError(response.data.message);
          }
        } catch (error) {
          this.loader = false;
          console.error(error);
        }
      } else {
        this.docError = "Document is required";
      }
    },
    fileUpload(event) {
      console.log(event.name);
      if (event && event.name) {
        this.docError = "";
        this.error = false;
      } else {
        this.docError = "Document is required";
        this.error = true;
      }
    },
    open() {
      this.$refs.selfiefile.$el.querySelector("input").click();
    },
    returnBusinessDocs(val, documents) {
      for (let doc in documents) {
        if (doc === val) {
          this.EntityDocs = documents[doc].map((docval) => {
            return {
              doc_name: docval,
              doc_val: null,
              doc_url: null,
              isactive: false,
            };
          });
        }
        if (val === "Private Limited Companies (Sdn Bhd)") {
          this.EntityDocs = this.EntityDocs.filter((ele) => {
            if (ele.doc_name.code != this.hideForm) {
              return ele;
            }
          });
        }
      }
      this.getBusinessInfo();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";

.invalid-feedback-name {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
</style>
